import { useQuery } from "@tanstack/react-query";
import { journeyQueryKeys } from "./keys";
import JourneyService from "../services";
import { TEST_CASE_STATUS } from "../components/TestCasesTab/constants";

export const useSingleJourney = (journeyId) => {
    return useQuery({
        queryKey: [journeyQueryKeys.singleJourney, journeyId],
        queryFn: () => JourneyService.getJourneyById(journeyId),
        enabled: !!journeyId,
    });
}

export const useJourneyTestCases = ({journeyId, page, limit, searchQuery, sortConfig}) => {
    return useQuery({
        queryKey: [journeyQueryKeys.journeyTestCases, page, limit, journeyId, searchQuery, sortConfig],
        queryFn: async () => {
            const response = await JourneyService.getJourneyTestCases({ journeyId, page, limit, searchQuery, sortConfig });
            console.log("response", response);
            const normalizeStatus = (status) => {
                const value = String(status || "").toUpperCase();
                const normalizedValue = value.replace(/\s+/g, "_");

                if (
                    normalizedValue === TEST_CASE_STATUS.running ||
                    normalizedValue === "IN_PROGRESS"
                )
                    return TEST_CASE_STATUS.running;
                if (normalizedValue === TEST_CASE_STATUS.pending)
                    return TEST_CASE_STATUS.pending;
                if (normalizedValue === TEST_CASE_STATUS.completed) return TEST_CASE_STATUS.completed;
                if (normalizedValue === TEST_CASE_STATUS.initialFailure) return TEST_CASE_STATUS.initialFailure;
                if (normalizedValue === TEST_CASE_STATUS.failed) return TEST_CASE_STATUS.failed;
                if (normalizedValue === "DRAFT")
                    return TEST_CASE_STATUS.draft;
                return status || TEST_CASE_STATUS.draft;
            };

            const testCases = (response?.testCases || []).map((tc) => ({
                ...tc,
                status: normalizeStatus(tc.status),
            }));
            
            return {
                testCases,
                total: response?.count || 0,
                totalRun: 0,
            };
        },
        enabled: !!journeyId, 
        placeholderData: (prev) => prev,
    });
}
